import { useAtomValue } from 'jotai'
import { IconArrowInbox, Button, Tooltip } from '@sequencehq/core-components'
import { match } from 'ts-pattern'

import {
  humanReadableInvoiceNumberAtom,
  invoiceIdAtom,
  invoiceStatusAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { useDownloadInvoicePdf } from 'Invoices/hooks/useDownloadInvoicePdf'

type Props = {
  variant?: 'button' | 'icon'
}

export const ButtonDownloadPdf = ({ variant = 'button' }: Props) => {
  const { downloadPdf } = useDownloadInvoicePdf()

  const invoiceId = useAtomValue(invoiceIdAtom)
  const invoiceNumber = useAtomValue(humanReadableInvoiceNumberAtom)
  const invoiceStatus = useAtomValue(invoiceStatusAtom)

  const icon = <IconArrowInbox color="inherit" />
  const label = 'Download PDF'

  const buttonProps = match(variant)
    .with('button', () => ({ leadingIcon: icon, children: label }))
    .with('icon', () => ({ icon, 'aria-label': label }))
    .exhaustive()

  const button = (
    <Button
      variant="secondary"
      onClick={() => {
        if (!invoiceId || !invoiceStatus) return
        downloadPdf({ invoiceId, invoiceNumber, invoiceStatus })
      }}
      data-testid="header.button.download-pdf"
      {...buttonProps}
    />
  )

  if (variant === 'icon') {
    return <Tooltip label={label}>{button}</Tooltip>
  }

  return button
}
